import Model from 'flarum/common/Model';
export default class OAuthConsent extends Model {
  clientId = (() => Model.attribute('clientId'))();
  clientName = (() => Model.attribute('clientName'))();
  clientLogoUrl = (() => Model.attribute('clientLogoUrl'))();
  clientSource = (() => Model.attribute('clientSource'))();
  clientSourceHost = (() => Model.attribute('clientSourceHost'))();
  scopes = (() => Model.attribute('scopes'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  lastUsedAt = (() => Model.attribute('lastUsedAt', Model.transformDate))();
  lastIpAddress = (() => Model.attribute('lastIpAddress'))();
}
flarum.reg.add('flarum-oauth-provider', 'forum/models/OAuthConsent', OAuthConsent);